module.exports = __webpack_public_path__ + "static/media/007-star-blue.e6fbe447.svg";